"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _useMediaQuery = _interopRequireDefault(require("./hooks/useMediaQuery"));
var _containers = require("./containers");
var _components = require("./components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function App(_ref) {
  var config = _ref.config;
  var _useState = (0, _react.useState)(config.defaultScenarioGroup),
    _useState2 = _slicedToArray(_useState, 2),
    mainScenario = _useState2[0],
    setMainScenario = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    compareScenario = _useState4[0],
    setCompareScenario = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showDifference = _useState6[0],
    setShowDifference = _useState6[1];
  var cache = (0, _react.useRef)({});
  var maxChartWidth = config.maxChartWidth ? config.maxChartWidth : 450;
  var applyMaxChartWidth = (0, _useMediaQuery["default"])("(min-width: ".concat(maxChartWidth, "px)"));
  var chartWidth = applyMaxChartWidth ? maxChartWidth : 450;
  var chartWidthScaling = chartWidth / maxChartWidth;
  var titles = {
    chartsTitles: config.titles.charts,
    scenarioTitles: config.titles.scenarios,
    seriesTitles: config.titles.series
  };
  (0, _react.useEffect)(function () {
    if (!compareScenario) {
      setShowDifference(false);
    }
  }, [compareScenario]);
  return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react["default"].createElement(_components.PageLoading, null)
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "/",
    element: /*#__PURE__*/_react["default"].createElement(_containers.Layout, config)
  }, config.landingPage ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    index: true,
    element: /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Navigate, {
      to: config.landingPage,
      replace: true
    })
  }) : /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    index: true,
    element: /*#__PURE__*/_react["default"].createElement(_components.Page, {
      cache: cache,
      basePath: config.basePath,
      name: "index"
    })
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: ":pageId",
    element: /*#__PURE__*/_react["default"].createElement(_components.Page, {
      cache: cache,
      basePath: config.basePath
    })
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: config.chartsPath,
    element: /*#__PURE__*/_react["default"].createElement(_components.ChartsPage, _extends({}, config, {
      selectedScenarios: [mainScenario, compareScenario],
      showDifference: showDifference,
      setMainScenario: setMainScenario,
      setCompareScenario: setCompareScenario,
      setShowDifference: setShowDifference
    }))
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    index: true,
    element: /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Navigate, {
      to: config.routes[0].path,
      replace: true
    })
  }), config.routes.map(function (route, idx) {
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      key: idx,
      path: route.path,
      element: route.charts && /*#__PURE__*/_react["default"].createElement(_components.Charts, _extends({
        selectedScenarios: [mainScenario, compareScenario],
        showDifference: showDifference,
        basePath: config.basePath,
        charts: route.charts,
        chartsInfo: config.chartsInfo,
        cache: cache,
        xDomainPadding: config.xDomainPadding,
        xGridValues: config.xGridValues,
        xGridMarks: config.xGridMarks,
        fixedDomain: config.fixedDomain,
        chartWidth: chartWidth,
        chartWidthScaling: chartWidthScaling,
        stackbarOffset: config.stackbarOffset,
        padding: config.chartPadding,
        barWidth: config.barWidth
      }, titles))
    }, route.routes && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      index: true,
      element: /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Navigate, {
        to: route.routes[0].path,
        replace: true
      })
    }), route.routes.map(function (route, idx) {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        key: idx,
        path: route.path,
        element: route.charts && /*#__PURE__*/_react["default"].createElement(_components.Charts, _extends({
          selectedScenarios: [mainScenario, compareScenario],
          showDifference: showDifference,
          basePath: config.basePath,
          charts: route.charts,
          chartsInfo: config.chartsInfo,
          cache: cache,
          xDomainPadding: config.xDomainPadding,
          xGridValues: config.xGridValues,
          xGridMarks: config.xGridMarks,
          fixedDomain: config.fixedDomain,
          chartWidth: chartWidth,
          chartWidthScaling: chartWidthScaling,
          stackbarOffset: config.stackbarOffset,
          padding: config.chartPadding,
          barWidth: config.barWidth
        }, titles))
      });
    })));
  })))));
}
var _default = App;
exports["default"] = _default;